import { Navigate, Outlet } from "react-router-dom";
import { AdminPatientsProvider } from "@/portals/admin/context/AdminPatientsContext";
import { useAdminAuthStore } from "@/stores/adminAuthStore";
import { AdminLayout } from "@/portals/admin/layout/AdminLayout";
import { useIdleLogout } from "@/portals/admin/hooks/useIdleLogout";
import { PageSpinner } from "@/shared/components/spinner";

function SessionLoader() {
  return (
    <div className="bg-white">
      <PageSpinner fullScreen />
    </div>
  );
}

export function AdminProtectedLayout() {
  const isAuthenticated = useAdminAuthStore((s) => s.isAuthenticated);
  const isLoading = useAdminAuthStore((s) => s.isLoading);
  useIdleLogout();

  if (isLoading) return <SessionLoader />;
  if (!isAuthenticated) return <Navigate to="/admin/signin" replace />;

  return (
    <AdminPatientsProvider>
      <AdminLayout>
        <Outlet />
      </AdminLayout>
    </AdminPatientsProvider>
  );
}
